module.exports = __webpack_public_path__ + "static/media/mushrooms.57a2501c.mp4";